import { BASE_URL_SANCTUM } from './misc/consts';

export const locale = () => document.documentElement.lang;

export const xsfrToken = async () => {
  const response = await fetch(BASE_URL_SANCTUM);
  if (!response.ok) {
    throw new Error(`Error! status: ${response.status}`);
  }
};
